import { FileText, Heart, BellRing, TrendingUp, Sparkles, Award } from "lucide-react";

const STAT_META = {
  applications: { icon: FileText, label: "Candidaturas", accent: "amber" },
  active: { icon: TrendingUp, label: "Em progresso", accent: "emerald" },
  saved: { icon: Heart, label: "Favoritos", accent: "rose" },
  alerts: { icon: BellRing, label: "Alertas ativos", accent: "blue" },
  matches: { icon: Sparkles, label: "Recomendações", accent: "violet" },
  referrals: { icon: Award, label: "Convidados", accent: "slate" },
};

const ACCENT_STYLES = {
  amber: "bg-amber-50 text-amber-700",
  emerald: "bg-emerald-50 text-emerald-700",
  rose: "bg-rose-50 text-rose-700",
  blue: "bg-blue-50 text-blue-700",
  violet: "bg-violet-50 text-violet-700",
  slate: "bg-slate-100 text-slate-700",
};

export function CandidateStatsCards({ stats, onCardClick }) {
  const entries = Object.entries(stats).filter(([key]) => STAT_META[key]);
  return (
    <div
      data-testid="candidate-stats-cards"
      className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 mb-6">
      {entries.map(([key, value]) => {
        const meta = STAT_META[key];
        const Icon = meta.icon;
        const clickable = typeof onCardClick === "function";
        return (
          <button
            key={key}
            type="button"
            data-testid={`stat-${key}`}
            onClick={clickable ? () => onCardClick(key) : undefined}
            disabled={!clickable}
            className={`text-left bg-white rounded-2xl border border-black/5 p-4 shadow-sm transition ${
              clickable ? "hover:border-slate-200 hover:shadow-md cursor-pointer" : "cursor-default"
            }`}>
            <div className={`w-9 h-9 rounded-full flex items-center justify-center mb-3 ${ACCENT_STYLES[meta.accent]}`}>
              <Icon className="w-4.5 h-4.5" />
            </div>
            <p className="font-heading font-black tracking-tighter text-2xl text-slate-900 leading-none">{value ?? 0}</p>
            <p className="text-[11px] uppercase tracking-[0.15em] font-bold text-slate-500 mt-2">{meta.label}</p>
          </button>
        );
      })}
    </div>
  );
}
